export default __webpack_public_path__ + "static/logapps-a6a8ca95289f95cba462422fe82c37ef.svg";